module.exports = __webpack_public_path__ + "static/media/class_diag.346825fd.svg";